var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9376 4.5V8.625H36.4585L30.797 14.2866C24.4032 9.33094 15.1407 9.78656 9.27759 15.6525C2.91759 22.0134 2.91759 32.3616 9.28134 38.7188C12.3428 41.771 16.4895 43.485 20.8126 43.485C25.1357 43.485 29.2824 41.771 32.3438 38.7188C38.2098 32.8519 38.6654 23.5931 33.7098 17.1994L39.3751 11.5416V17.0625H43.5001V4.5H30.9376ZM29.4301 35.805C27.1429 38.0874 24.0437 39.3692 20.8126 39.3692C17.5814 39.3692 14.4822 38.0874 12.1951 35.805C7.4429 31.0538 7.4429 23.3213 12.1951 18.57C16.9473 13.8188 24.6788 13.8178 29.4301 18.57C34.1813 23.3222 34.1823 31.0538 29.4301 35.805Z",
    fill: "#185EDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/Male.4ec6c03a032e74e92e9be57d1e0c1a7c.svg";
export { ForwardRef as ReactComponent };